const MAX_VISIBLE_PINS = 150;

export function getVisibleMapDogs(dogs, bounds, selectedDogId, limit = MAX_VISIBLE_PINS) {
  const selected = dogs.find((dog) => dog.id === selectedDogId);
  const visible = [];
  // Wait for the viewport before downloading profile photos outside it.
  if (bounds) {
    for (const dog of dogs) {
      if (visible.length >= limit - (selected ? 1 : 0)) break;
      if (dog === selected) continue;
      const { lat, lng } = dog.displayCoords;
      const inLongitude = bounds.w <= bounds.e
        ? lng >= bounds.w && lng <= bounds.e
        : lng >= bounds.w || lng <= bounds.e;
      if (Number.isFinite(lat) && Number.isFinite(lng) &&
          lat >= bounds.s && lat <= bounds.n && inLongitude) {
        visible.push(dog);
      }
    }
  }
  if (selected) visible.push(selected);
  return visible;
}
